import { AlertDialog, Flex, Button } from '@radix-ui/themes';

interface ConfirmAlertDialogProps<T> {
    disabledConfirm?: boolean;
    open: boolean;
    onOpenChange: (open: boolean) => void;
    title: string;
    item: T | null; 
    onConfirm: (item: T) => void; 
    onCancel: () => void;
    descriptionComponent?: React.ReactNode; 
}

export const ConfirmAlertDialog = <T,>({
    open,
    onOpenChange,
    title,
    item,
    onConfirm,
    onCancel,
    disabledConfirm = false,
    descriptionComponent
}: ConfirmAlertDialogProps<T>) => {
    return (
        <AlertDialog.Root open={open} onOpenChange={onOpenChange}>
            <AlertDialog.Content maxWidth="450px">
                <AlertDialog.Title>{title}</AlertDialog.Title>
                <Flex gap="3" mt="4" justify="end" direction="column">
                    {descriptionComponent ? (
                        <>
                            {descriptionComponent}
                            <AlertDialog.Description className="AlertDialogDescription" />
                        </>
                    ) : (
                        <AlertDialog.Description className="AlertDialogDescription" />
                    )}
                    <Flex gap="3" justify="end" mt="4">
                        <AlertDialog.Cancel>
                            <Button variant="soft" color="gray" onClick={onCancel}>
                                Cancelar
                            </Button>
                        </AlertDialog.Cancel>
                        <AlertDialog.Action disabled={disabledConfirm}> 
                            <Button variant="solid" color="red" onClick={() => item && onConfirm(item)}>
                                Continuar
                            </Button>
                        </AlertDialog.Action>
                    </Flex>
                </Flex>
            </AlertDialog.Content>
        </AlertDialog.Root>
    );
};
